import {Component, input, signal} from '@angular/core';
import {isNotNullOrUndefined} from 'sigale-angular';
import {Ilot} from '../model/ilot.model';
import {Bureau} from '../model/bureau.model';
import {Duree} from '../../shared/models/duree.model';
import {UtilisateurSigalett} from '../../shared/models/utilisateur-sigalett.model';

@Component({
	selector: 'app-affichage-ilot-pour-reservation',
	templateUrl: './affichage-ilot-pour-reservation.component.html',
	styleUrl: './affichage-ilot-pour-reservation.component.scss'
})
export class AffichageIlotPourReservationComponent {

	readonly = input.required<boolean>();
	ilot = input.required<Ilot>();
	dateReservation = input.required<Date>();
	duree = input.required<Duree>();
	longueurParent = input.required<number>();
	hauteurParent = input.required<number>();
	labelHaut = input<string>('');
	labelDroite = input<string>('');
	labelBas = input<string>('');
	labelGauche = input<string>('');
	estAffichageVertical = input.required<boolean>();
	bureauPreferentielId = input<number | null>(null);
	utilisateurConnecte = input<UtilisateurSigalett>();

	showReserverBureauModal = signal(false);
	bureauSelectionne = signal<Bureau>(null);
	dureeReservation = signal<Duree>(Duree.JOURNEE);

	/**
	 * Affiche la modale de réservation lorsque l'on clique sur un bureau.
	 *
	 * @param bureau le bureau sur lequel on a cliqué.
	 */
	onClickBureau(bureau: Bureau): void {
		if (!this.readonly()) {
			this.determinerDureePourReservation(bureau);
			this.bureauSelectionne.set(bureau);
			this.showReserverBureauModal.set(true);
		}
	}

	/**
	 * Si la réservation se fait sur une journée et que le bureau est occupé sur une demi-journée alors on réserve seulement sur la demi-journée libre.
	 *
	 * @param bureau le bureau concerné.
	 */
	determinerDureePourReservation(bureau: Bureau): void {
		if (this.duree() === Duree.JOURNEE) {
			if (bureau.reserverSeulementMatin()) {
				this.dureeReservation.set(Duree.APRES_MIDI);
			}

			if (bureau.reserverSeulementApresMidi()) {
				this.dureeReservation.set(Duree.MATIN);
			}
		}
		else {
			this.dureeReservation.set(this.duree());
		}
	}

	protected readonly isNotNullOrUndefined = isNotNullOrUndefined;
}
